<ng-container *transloco="let t;">

  <div class="card p-mb-4" [ngClass]="{'card-disabled': disabled === true }">

    <p [innerHtml]="texts.orderform_date_before"></p>

    <h2>{{ t('common.labels.date_suggestions') }}</h2>

    <p *ngIf="submitted === true && dates.length > 0 && subForm.get('date').valid === false" class="error"><strong>{{ t('orderform.please_select_date') }}</strong></p>

    <div class="p-grid">
      <div class="p-col-4">
        <span class="p-field-acr">
          <label>{{ t('common.labels.date') }}</label>
        </span>
        <div class="date-list" [ngClass]="{ disabled: dates.length === 0 }">
          <app-loader [loading]="loading"></app-loader>
          <div *ngIf="error === true" class="info-notice">
            <p class="p-text-center p-mt-4 p-mb-2">
              <i class="pi pi-exclamation-circle"></i>
            </p>
            <p class="p-text-center p-mt-2 p-mb-4">
              {{ t('orderform.no_suggestions') }}
            </p>
          </div>
          <p-table *ngIf="loading !== true && dates.length > 0" [value]="dates" styleClass="p-datatable-sm">
            <ng-template pTemplate="body" let-date>
              <tr *ngIf="date.text === true" class="date-hint">
                <td colspan="2" [innerHtml]="texts.orderform_date_break"></td>
              </tr>
              <tr (click)="toggleDate(date)" [ngClass]="{'selected': date.selected === true}">
                <td><span>{{ date.date | amDateFormat: 'DD.MM.YYYY' }} <i *ngIf="date.selected === true" class="pi pi-check p-ml-2"></i></span></td>
                <td class="p-text-right" [pTooltip]="date.info">
                  <ng-container *ngIf="date.selected !== true" [ngSwitch]="date.status">
                    <button *ngSwitchCase="'yellow'" type="button" pButton [label]="t('common.labels.request')" class="p-button-sm p-button-warning"></button>
                    <button *ngSwitchCase="'green'" type="button" pButton [label]="t('common.labels.book_direct')" class="p-button-sm p-button-success"></button>
                  </ng-container>
                  <button *ngIf="date.selected === true" type="button" pButton [label]="t('common.labels.selected')" class="p-button-sm p-button-outlined p-button-secondary"></button>
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
      <div class="p-col-4">
        <app-form-control [cid]="'time'" [control]="form.get('date.time')" [type]="'select'" [options]="times" [label]="t('common.labels.starttime')"></app-form-control>
      </div>
    </div>

    <p [innerHtml]="texts.orderform_date_after"></p>

    <div class="disabled-screen"><i class="pi pi-lock"></i></div>

  </div>

</ng-container>
